// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__34h_U","colMin":"styles_colMin__3YlO7"};